/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Marketing_Next_TitleInputs */

const en_wb_marketing_next_title = /** @type {(inputs: Wb_Marketing_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggested next check`)
};

const lv_wb_marketing_next_title = /** @type {(inputs: Wb_Marketing_Next_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ieteicamā nākamā pārbaude`)
};

/**
* | output |
* | --- |
* | "Suggested next check" |
*
* @param {Wb_Marketing_Next_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_marketing_next_title = /** @type {((inputs?: Wb_Marketing_Next_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Marketing_Next_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_marketing_next_title(inputs)
	return en_wb_marketing_next_title(inputs)
});